import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `<KnowledgeFactorStep />` — patient enters password (knowledge
 * factor per PFO §2.2).
 *
 * **Doctrinal posture.** The password input does not auto-fill
 * from any persistence surface. Browser autofill is allowed (it's
 * patient-controlled), but the app does not seed the input from
 * any retained source. The knowledge factor is held in component
 * state until the patient submits, then handed to the orchestrator
 * which clears the local copy after PMK derivation.
 */
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
export function KnowledgeFactorStep(props) {
    const { t } = useLocale();
    const [password, setPassword] = React.useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        if (password.length === 0) {
            return;
        }
        props.onSubmit(password);
        // Clear the local state copy; orchestrator now holds the
        // factor in flow state until PMK derivation initiates.
        setPassword('');
    };
    return (_jsxs("section", { "aria-labelledby": "knowledge-heading", children: [_jsx("h3", { id: "knowledge-heading", children: t('authentication.knowledge_factor.heading') }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("label", { children: [t('authentication.knowledge_factor.password_label'), _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), autoComplete: "current-password", required: true })] }), _jsxs("div", { role: "group", "aria-label": t('authentication.knowledge_factor.actions_aria_label'), children: [_jsx("button", { type: "submit", disabled: password.length === 0, children: t('authentication.knowledge_factor.submit') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('authentication.knowledge_factor.cancel') })] })] })] }));
}
//# sourceMappingURL=knowledge-factor-step.js.map